import * as i0 from "@angular/core";
var INDRAURLService = /** @class */ (function () {
    function INDRAURLService() {
        this.escapeArray = [
            { character: ' ', escapeCode: '%20' },
            { character: ';', escapeCode: '%3B' }
        ];
    }
    INDRAURLService.prototype.INDRA_getEscapedUrl = function (url) {
        if (url) {
            this.escapeArray.forEach(function (escapeItem) {
                url = url.replace(escapeItem.character, escapeItem.escapeCode);
            });
        }
        return url;
    };
    INDRAURLService.prototype.INDRA_updateMaskedField = function (url, mask, replacementValue) {
        if (url && url.includes(mask)) {
            url = url.replace(mask, replacementValue);
        }
        return url;
    };
    INDRAURLService.prototype.INDRA_getUrlParams = function (name, url) {
        if (!url)
            url = location.href;
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regexS = "[\\?&]" + name + "=([^&#]*)";
        var regex = new RegExp(regexS);
        var results = regex.exec(url);
        return results == null ? null : results[1];
    };
    INDRAURLService.prototype.INDRA_getFilteredParams = function (queryParams) {
        return Object.keys(queryParams)
            .reduce(function (obj, key) {
            obj[key] = queryParams[key];
            return obj;
        }, {});
    };
    INDRAURLService.ngInjectableDef = i0.defineInjectable({ factory: function INDRAURLService_Factory() { return new INDRAURLService(); }, token: INDRAURLService, providedIn: "root" });
    return INDRAURLService;
}());
export { INDRAURLService };
